<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-select2 v-model.number="model.username"
                 label="User"
                 placeholder="Nhập username..."
                 uri="cms/api/v1.0/admin/role-user/users/select2"
                 validate-rules="required"
      />

      <c-select2 v-model.number="model.roleId"
                 label="Vai trò"
                 placeholder="Nhập mã vai trò"
                 uri="cms/api/v1.0/admin/roles/select2"
                 validate-rules="required"
      />

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        username: null,
        roleId: null,
      },
    }
  },
  methods: {
    resetForm() {
      this.model = {
        username: null,
        roleId: null,
      };
    },
    submit() {
      this.$showLoader();
      let data = {
        "username": this.model.username,
        "roleId": this.model.roleId
      }

      this.$http
          .post('/cms/api/v1.0/admin/role-user', data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes);
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>